import axios from 'axios'

import {
  ADD_ROLE_FAIL,
  ADD_ROLE_REQUEST,
  ADD_ROLE_SUCCESS,
  GET_ROLES_FAIL,
  GET_ROLES_REQUEST,
  GET_ROLES_SUCCESS,
  GET_ROLE_BY_ID_FAIL,
  GET_ROLE_BY_ID_REQUEST,
  GET_ROLE_BY_ID_SUCCESS,
  UPDATE_ROLE_FAIL,
  UPDATE_ROLE_REQUEST,
  UPDATE_ROLE_SUCCESS,
} from '../constants/roleConstants'
import { logout } from './userActions'

const baseUrl = process.env.REACT_APP_API_URL;

export const getRoles = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_ROLES_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.get(`${baseUrl}/roles`, config)

    dispatch({
      type: GET_ROLES_SUCCESS,
      payload: data,
    })
  } catch (error) {
    // if (error.response.status === 401) {
    //   dispatch(logout())
    //   return
    // }
    dispatch({
      type: GET_ROLES_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const addRole =
  (
    name,
    tasksView,
    tasksDetailsView,
    tasksUpdate,
    tasksAddCustomer,
    tasksAddAllocation,
    allocationPendingTasks,
    visitPendingTasks,
    inProgressTasks,
    finalisationPendingTasks,
    completedTasks,
    waivedTasks,
    calling,
    taskSummary,
    transfers,
    usersView,
    usersAdd,
    usersUpdate,
    viewAttendance,
    rejoinUsers,
    viewUnassignTasks,
    viewTransfferedTasks,
    viewFieldTasks,
    resignedUsers,
    rolesView,
    rolesAdd,
    rolesUpdate,
    customersView,
    customersAdd,
    customersUpdate,
    appAccess,
    webAccess,
    settings,
    reports,
    pincodes,
    dashboard,
    processView,
    processAdd,
    ProcessUpdate,
    ProcessDelete,
    assignProcessView,
    assignProcessAdd,
    assignProcessUpdate,
    assignProcessDelete,
    DailyCollectionView,
    DailyCollectionViewAdd,
    DailyCollectionViewUpdate,
    DailyCollectionViewDelete,
    mis,
    driveNbfcDelhi,
    driveNbfcHaryana,
    driveNbfcUp,
    driveNbfcTata,
    driveHdfcCard,
    driveHdfcRetail,
    driveIdfc,
    driveKotak,
    verificationProcessView,
    verificationProcessAdd,
    verificationProcessUpdate,
    verificationProcessDelete,
    assignVerificationProcessView,
    assignVerificationProcessAdd,
    assignVerificationProcessUpdate,
    assignVerificationProcessDelete,
    verificationMisAdd,
    verificationMisUpdate,
    verificationMisDelete,
    verificationMisView,
    verificationMisReport,
    driveHdfcCardUp,
    driveHdfcRetailUp,
    exportRole,
    prospectForm,
    companyView,
    companyAdd,
    companyUpdate,
    companyDelete,
    salaryView,
    salaryUpload,
    salaryUpdate,
    salaryDelete,
    salaryStats,
    advanceView,
    advanceUpload,
    advanceUpdate,
    advanceDelete,
    attendanceView,
    attendanceUpload,
    attendanceUpdate,
    attendanceDelete,
    attendanceStats,
    bonusMaster,
    exportBankSheet,
    salaryApproval,
    accessCollectionType,
    accessVerificationType,
    accessStandardType,
    employeeMasterView,
    employeeMasterAdd,
    employeeMasterUpdate,
    employeeMasterDelete,
    employeeMasterMarkLeft,
    employeeMasterUpload,
    employeeLeftView,
    employeeLeftAdd,
    employeeLeftUpdate,
    employeeLeftDelete,
    employeeLeftRejoin,
    employeeLeftUpload,
    advanceCurrentMonthOnly,
    attendanceCurrentMonthOnly,
    bonusCurrentMonthOnly,
    priceMasterView,
    priceMasterImport,
    priceMasterDelete,
    reimbursementMasterView,
    reimbursementMasterImport,
    reimbursementMasterDelete,
    caseMasterView,
    caseMasterImport,
    caseMasterDelete,
    penaltyMasterView,
    penaltyMasterImport,
    penaltyMasterDelete,
    conveyanceMasterView,
    conveyanceMasterImport,
    conveyanceMasterDelete,
    verificationReportView,
    verificationReportGenerate,
    verificationReportExport,
    verificationReportEdit,
    consolidatedMisView,
    consolidatedMisExport,
    supervisorMasterView,
    supervisorMasterAdd,
    supervisorMasterUpdate,
    supervisorMasterDelete,
    billingMasterView,
    billingMasterAdd,
    billingMasterUpdate,
    billingMasterDelete,
    billingMasterStatusUpdate,
    provisionalBillingView,
    provisionalBillingSubmit,
    provisionalBillingUpdate,
    provisionalBillingFillOnBehalf,
    distributionView,
    distributionAdd,
    distributionUpdate,
    collectionMisView,
    collectionMisOverridePaid
  ) =>
    async (dispatch, getState) => {
      try {
        dispatch({
          type: ADD_ROLE_REQUEST,
        })

        const {
          userLogin: { userInfo },
        } = getState()

        const config = {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${userInfo.token}`,
          },
        }

        const { data } = await axios.post(
          `${baseUrl}/roles`,
          {
            name,
            tasksView,
            tasksDetailsView,
            tasksUpdate,
            tasksAddCustomer,
            tasksAddAllocation,
            allocationPendingTasks,
            visitPendingTasks,
            inProgressTasks,
            finalisationPendingTasks,
            completedTasks,
            waivedTasks,
            calling,
            taskSummary,
            transfers,
            usersView,
            usersAdd,
            usersUpdate,
            viewAttendance,
            rejoinUsers,
            viewUnassignTasks,
            viewTransfferedTasks,
            viewFieldTasks,
            resignedUsers,
            rolesView,
            rolesAdd,
            rolesUpdate,
            customersView,
            customersAdd,
            customersUpdate,
            appAccess,
            webAccess,
            settings,
            reports,
            pincodes,
            dashboard,
            processView,
            processAdd,
            ProcessUpdate,
            ProcessDelete,
            assignProcessView,
            assignProcessAdd,
            assignProcessUpdate,
            assignProcessDelete,
            DailyCollectionView,
            DailyCollectionViewAdd,
            DailyCollectionViewUpdate,
            DailyCollectionViewDelete,
            mis,
            driveNbfcDelhi,
            driveNbfcHaryana,
            driveNbfcUp,
            driveNbfcTata,
            driveHdfcCard,
            driveHdfcRetail,
            driveIdfc,
            driveKotak,
            verificationProcessView,
            verificationProcessAdd,
            verificationProcessUpdate,
            verificationProcessDelete,
            assignVerificationProcessView,
            assignVerificationProcessAdd,
            assignVerificationProcessUpdate,
            assignVerificationProcessDelete,
            verificationMisAdd,
            verificationMisUpdate,
            verificationMisDelete,
            verificationMisView,
            verificationMisReport,
            driveHdfcCardUp,
            driveHdfcRetailUp,
            export: exportRole,
            prospectForm,
            companyView,
            companyAdd,
            companyUpdate,
            companyDelete,
            salaryView,
            salaryUpload,
            salaryUpdate,
            salaryDelete,
            salaryStats,
            advanceView,
            advanceUpload,
            advanceUpdate,
            advanceDelete,
            attendanceView,
            attendanceUpload,
            attendanceUpdate,
            attendanceDelete,
            attendanceStats,
            bonusMaster,
            exportBankSheet,
            salaryApproval,
            accessCollectionType,
            accessVerificationType,
            accessStandardType,
            employeeMasterView,
            employeeMasterAdd,
            employeeMasterUpdate,
            employeeMasterDelete,
            employeeMasterMarkLeft,
            employeeMasterUpload,
            employeeLeftView,
            employeeLeftAdd,
            employeeLeftUpdate,
            employeeLeftDelete,
            employeeLeftRejoin,
            employeeLeftUpload,
            advanceCurrentMonthOnly,
            attendanceCurrentMonthOnly,
            bonusCurrentMonthOnly,
            priceMasterView,
            priceMasterImport,
            priceMasterDelete,
            reimbursementMasterView,
            reimbursementMasterImport,
            reimbursementMasterDelete,
            caseMasterView,
            caseMasterImport,
            caseMasterDelete,
            penaltyMasterView,
            penaltyMasterImport,
            penaltyMasterDelete,
            conveyanceMasterView,
            conveyanceMasterImport,
            conveyanceMasterDelete,
            verificationReportView,
            verificationReportGenerate,
            verificationReportExport,
            verificationReportEdit,
            consolidatedMisView,
            consolidatedMisExport,
            supervisorMasterView,
            supervisorMasterAdd,
            supervisorMasterUpdate,
            supervisorMasterDelete,
            billingMasterView,
            billingMasterAdd,
            billingMasterUpdate,
            billingMasterDelete,
            billingMasterStatusUpdate,
            provisionalBillingView,
            provisionalBillingSubmit,
            provisionalBillingUpdate,
            provisionalBillingFillOnBehalf,
            distributionView,
            distributionAdd,
            distributionUpdate,
            collectionMisView,
            collectionMisOverridePaid
          },
          config
        )

        dispatch({
          type: ADD_ROLE_SUCCESS,
          payload: data,
        })
      } catch (error) {
        // if (error.response.status === 401) {
        //   dispatch(logout())
        //   return
        // }
        dispatch({
          type: ADD_ROLE_FAIL,
          payload:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        })
      }
    }

export const getRoleByID = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_ROLE_BY_ID_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.get(`${baseUrl}/roles/${id}`, config)

    dispatch({
      type: GET_ROLE_BY_ID_SUCCESS,
      payload: data,
    })
  } catch (error) {
    if (error.response.status === 401) {
      dispatch(logout())
      return
    }
    dispatch({
      type: GET_ROLE_BY_ID_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const updateRole =
  (
    id,
    tasksView,
    tasksDetailsView,
    tasksUpdate,
    tasksAddCustomer,
    tasksAddAllocation,
    allocationPendingTasks,
    visitPendingTasks,
    inProgressTasks,
    finalisationPendingTasks,
    completedTasks,
    waivedTasks,
    calling,
    taskSummary,
    transfers,
    usersView,
    usersAdd,
    usersUpdate,
    viewAttendance,
    rejoinUsers,
    viewUnassignTasks,
    viewTransfferedTasks,
    viewFieldTasks,
    resignedUsers,
    rolesView,
    rolesAdd,
    rolesUpdate,
    customersView,
    customersAdd,
    customersUpdate,
    appAccess,
    webAccess,
    settings,
    reports,
    pincodes,
    dashboard,
    processView,
    processAdd,
    ProcessUpdate,
    ProcessDelete,
    assignProcessView,
    assignProcessAdd,
    assignProcessUpdate,
    assignProcessDelete,
    DailyCollectionView,
    DailyCollectionViewAdd,
    DailyCollectionViewUpdate,
    DailyCollectionViewDelete,
    mis,
    driveNbfcDelhi,
    driveNbfcHaryana,
    driveNbfcUp,
    driveNbfcTata,
    driveHdfcCard,
    driveHdfcRetail,
    driveIdfc,
    driveKotak,
    verificationProcessView,
    verificationProcessAdd,
    verificationProcessUpdate,
    verificationProcessDelete,
    assignVerificationProcessView,
    assignVerificationProcessAdd,
    assignVerificationProcessUpdate,
    assignVerificationProcessDelete,
    verificationMisAdd,
    verificationMisUpdate,
    verificationMisDelete,
    verificationMisView,
    verificationMisReport,
    driveHdfcCardUp,
    driveHdfcRetailUp,
    exportRole,
    prospectForm,
    companyView,
    companyAdd,
    companyUpdate,
    companyDelete,
    salaryView,
    salaryUpload,
    salaryUpdate,
    salaryDelete,
    salaryStats,
    advanceView,
    advanceUpload,
    advanceUpdate,
    advanceDelete,
    attendanceView,
    attendanceUpload,
    attendanceUpdate,
    attendanceDelete,
    attendanceStats,
    bonusMaster,
    exportBankSheet,
    salaryApproval,
    accessCollectionType,
    accessVerificationType,
    accessStandardType,
    supervisorMasterView,
    supervisorMasterAdd,
    supervisorMasterUpdate,
    supervisorMasterDelete,
    billingMasterView,
    billingMasterAdd,
    billingMasterUpdate,
    billingMasterDelete,
    billingMasterStatusUpdate,
    provisionalBillingView,
    provisionalBillingSubmit,
    provisionalBillingUpdate,
    provisionalBillingFillOnBehalf,
    distributionView,
    distributionAdd,
    distributionUpdate,
    collectionMisView,
    collectionMisOverridePaid,
    employeeMasterView,
    employeeMasterAdd,
    employeeMasterUpdate,
    employeeMasterDelete,
    employeeMasterMarkLeft,
    employeeMasterUpload,
    employeeLeftView,
    employeeLeftAdd,
    employeeLeftUpdate,
    employeeLeftDelete,
    employeeLeftRejoin,
    employeeLeftUpload,
    advanceCurrentMonthOnly,
    attendanceCurrentMonthOnly,
    bonusCurrentMonthOnly,
    priceMasterView,
    priceMasterImport,
    priceMasterDelete,
    reimbursementMasterView,
    reimbursementMasterImport,
    reimbursementMasterDelete,
    caseMasterView,
    caseMasterImport,
    caseMasterDelete,
    penaltyMasterView,
    penaltyMasterImport,
    penaltyMasterDelete,
    conveyanceMasterView,
    conveyanceMasterImport,
    conveyanceMasterDelete,
    verificationReportView,
    verificationReportGenerate,
    verificationReportExport,
    verificationReportEdit,
    consolidatedMisView,
    consolidatedMisExport
  ) =>
    async (dispatch, getState) => {
      try {
        dispatch({
          type: UPDATE_ROLE_REQUEST,
        })

        const {
          userLogin: { userInfo },
        } = getState()

        const config = {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${userInfo.token}`,
          },
        }

        const { data } = await axios.put(
          `${baseUrl}/roles/${id}`,
          {
            tasksView,
            tasksDetailsView,
            tasksUpdate,
            tasksAddCustomer,
            tasksAddAllocation,
            allocationPendingTasks,
            visitPendingTasks,
            inProgressTasks,
            finalisationPendingTasks,
            completedTasks,
            waivedTasks,
            calling,
            taskSummary,
            transfers,
            usersView,
            usersAdd,
            usersUpdate,
            viewAttendance,
            rejoinUsers,
            viewUnassignTasks,
            viewTransfferedTasks,
            viewFieldTasks,
            resignedUsers,
            rolesView,
            rolesAdd,
            rolesUpdate,
            customersView,
            customersAdd,
            customersUpdate,
            appAccess,
            webAccess,
            settings,
            reports,
            pincodes,
            dashboard,
            processView,
            processAdd,
            ProcessUpdate,
            ProcessDelete,
            assignProcessView,
            assignProcessAdd,
            assignProcessUpdate,
            assignProcessDelete,
            DailyCollectionView,
            DailyCollectionViewAdd,
            DailyCollectionViewUpdate,
            DailyCollectionViewDelete,
            mis,
            driveNbfcDelhi,
            driveNbfcHaryana,
            driveNbfcUp,
            driveNbfcTata,
            driveHdfcCard,
            driveHdfcRetail,
            driveIdfc,
            driveKotak,
            verificationProcessView,
            verificationProcessAdd,
            verificationProcessUpdate,
            verificationProcessDelete,
            assignVerificationProcessView,
            assignVerificationProcessAdd,
            assignVerificationProcessUpdate,
            assignVerificationProcessDelete,
            verificationMisAdd,
            verificationMisUpdate,
            verificationMisDelete,
            verificationMisView,
            verificationMisReport,
            driveHdfcCardUp,
            driveHdfcRetailUp,
            export: exportRole,
            prospectForm,
            companyView,
            companyAdd,
            companyUpdate,
            companyDelete,
            salaryView,
            salaryUpload,
            salaryUpdate,
            salaryDelete,
            salaryStats,
            advanceView,
            advanceUpload,
            advanceUpdate,
            advanceDelete,
            attendanceView,
            attendanceUpload,
            attendanceUpdate,
            attendanceDelete,
            attendanceStats,
            bonusMaster,
            exportBankSheet,
            salaryApproval,
            accessCollectionType,
            accessVerificationType,
            accessStandardType,
            supervisorMasterView,
            supervisorMasterAdd,
            supervisorMasterUpdate,
            supervisorMasterDelete,
            billingMasterView,
            billingMasterAdd,
            billingMasterUpdate,
            billingMasterDelete,
            billingMasterStatusUpdate,
            provisionalBillingView,
            provisionalBillingSubmit,
            provisionalBillingUpdate,
            provisionalBillingFillOnBehalf,
            distributionView,
            distributionAdd,
            distributionUpdate,
            collectionMisView,
            collectionMisOverridePaid,
            employeeMasterView,
            employeeMasterAdd,
            employeeMasterUpdate,
            employeeMasterDelete,
            employeeMasterMarkLeft,
            employeeMasterUpload,
            employeeLeftView,
            employeeLeftAdd,
            employeeLeftUpdate,
            employeeLeftDelete,
            employeeLeftRejoin,
            employeeLeftUpload,
            advanceCurrentMonthOnly,
            attendanceCurrentMonthOnly,
            bonusCurrentMonthOnly,
            priceMasterView,
            priceMasterImport,
            priceMasterDelete,
            reimbursementMasterView,
            reimbursementMasterImport,
            reimbursementMasterDelete,
            caseMasterView,
            caseMasterImport,
            caseMasterDelete,
            penaltyMasterView,
            penaltyMasterImport,
            penaltyMasterDelete,
            conveyanceMasterView,
            conveyanceMasterImport,
            conveyanceMasterDelete,
            verificationReportView,
            verificationReportGenerate,
            verificationReportExport,
            verificationReportEdit,
            consolidatedMisView,
            consolidatedMisExport
          },
          config
        )

        dispatch({
          type: UPDATE_ROLE_SUCCESS,
          payload: data,
        })
      } catch (error) {
        if (error.response.status === 401) {
          dispatch(logout())
          return
        }
        dispatch({
          type: UPDATE_ROLE_FAIL,
          payload:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        })
      }
    }